// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basecamp-search__move-top-button[data-v-076c9ba4]{position:fixed;z-index:9999;right:20px;bottom:95px;display:block;width:60px;height:60px;border-radius:40px;transition:.3s;cursor:pointer;box-shadow:0 1px 6px 0 rgba(0,0,0,.06),0 2px 32px 0 rgba(0,0,0,.16)}.basecamp-search__move-top-button.fade-enter[data-v-076c9ba4],.basecamp-search__move-top-button.fade-leave-to[data-v-076c9ba4]{opacity:0}.basecamp-search__move-top-button img[data-v-076c9ba4]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
